
import { useParams } from "react-router-dom";
import { BackButton } from "@/components/ui/back-button";
import { Linkedin, Twitter } from "lucide-react";
import { blogPosts } from "@/data/blog-posts";
import { useToast } from "@/components/ui/use-toast";
import { Button } from "@/components/ui/button";

const BlogPost = () => {
  const { slug } = useParams();
  const { toast } = useToast();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return <div>Post not found</div>;
  }

  const shareUrl = window.location.href;
  const shareText = `Check out this post: ${post.title}`;

  const shareToLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank');
    toast({
      description: "Opening LinkedIn sharing dialog",
    });
  };

  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank');
    toast({
      description: "Opening X sharing dialog",
    });
  };

  return (
    <main className="min-h-screen bg-white">
      <article className="max-w-4xl mx-auto px-4 py-12">
        <BackButton />

        <h1 className="text-4xl font-medium mb-4">{post.title}</h1>
        <div className="flex items-center justify-between mb-8">
          <p className="text-gray-600">
            {new Date(post.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </p>
          <div className="flex gap-4">
            <Button variant="ghost" onClick={shareToLinkedIn}>
              <Linkedin className="h-5 w-5" />
            </Button>
            <Button variant="ghost" onClick={shareToTwitter}>
              <Twitter className="h-5 w-5" />
            </Button>
          </div>
        </div>

        <div className="prose prose-lg max-w-none">
          {post.content.split('\n\n').map((paragraph, index) => (
            <p key={index} className="mb-6">
              {paragraph}
            </p>
          ))}
        </div>
      </article>
    </main>
  );
};

export default BlogPost;
